<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>记账对账</el-breadcrumb-item>
				<el-breadcrumb-item>会计调整</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-date-picker
					type="month"
					placeholder="记账期号"
					v-model="query.period"
					value-format="yyyy-MM"
				></el-date-picker>&nbsp;
				<el-select v-model="query.adjustObjType" placeholder="请选择调整对象类型">
					<el-option key="" label="请选择调整对象类型" value=""></el-option>
					<el-option v-for="item in adjustObjectKv" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.adjustWay" placeholder="请选择调整方式类型">
					<el-option key="" label="请选择调整方式类型" value=""></el-option>
					<el-option v-for="item in adjustWayKv" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.accountingType" placeholder="请选择财务类型">
					<el-option key="" label="请选择财务类型" value=""></el-option>
					<el-option v-for="item in accountingTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="adjustObjType" label="调整对象类型" :formatter="adjustObjTypeFormat" width="120px"></el-table-column>
                <el-table-column prop="adjustWay" label="调整方式" :formatter="adjustWayFormat" width="100px"></el-table-column>
				<el-table-column prop="period" label="记账期号" width="100px"></el-table-column>
				<el-table-column prop="accountingType" label="会计类型" :formatter="accountingTypeFormat" width="100px"></el-table-column>
				<el-table-column prop="companyName" label="记账对象名称"></el-table-column>
				<el-table-column prop="amount" label="金额" width="120px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加新纪录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-input v-model="form.adjustKey" type="hidden"></el-input>
				<el-form-item label="调整对象类型" prop="adjustObjType">
					<el-select v-model="form.adjustObjType" placeholder="请选择调整对象类型">
						<el-option key="" label="请选择调整对象类型" value=""></el-option>
						<el-option v-for="item in adjustObjectKv" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="调整方式" prop="adjustWay">
					<el-select v-model="form.adjustWay" placeholder="请选择调整方式类型">
						<el-option key="" label="请选择调整方式类型" value=""></el-option>
						<el-option v-for="item in adjustWayKv" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关联内容" prop="adjustKey" v-if="form.adjustObjType > 0 && form.adjustWay > 0">
					<el-input v-model="form.title" readOnly style="width:80%;float:left"></el-input><el-link type="primary" @click = "adjustObjTypeChange(form.adjustObjType)" style="margin-left:5px;float:left">选择...</el-link>
                </el-form-item>
				<el-form-item label="记账期号" prop="period">
					<el-date-picker
							type="month"
							placeholder="记账期号, 记账簿记账是将对应期号的调整内容进行处理"
							v-model="form.period"
							value-format="yyyy-MM"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="财务类型" prop="accountingType" v-if="form.adjustWay<3">
					<el-select v-model="form.accountingType" placeholder="请选择财务类型">
						<el-option key="" label="请选择财务类型" value=""></el-option>
						<el-option v-for="item in accountingTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="记账对象名称" prop="companyName" v-if="form.adjustWay<3">
					<el-input v-model="form.companyName"></el-input>
                </el-form-item>
				<el-form-item label="调整金额" prop="amount" v-if="form.adjustWay<3">
					<el-input v-model="form.amount"></el-input>
                </el-form-item>
				<el-form-item label="摘要" prop="purpose" v-if="form.adjustWay<3">
					<el-input v-model="form.purpose"></el-input>
                </el-form-item>
                <el-form-item label="调整备注" prop="remark">
					<el-input type=textarea :rows=5 v-model="form.remark" placeholder="记录调整的原因，数据等信息"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="adjustDataTitle" :visible.sync="adjustDataVisible" width="70%">
			<div class="handle-box">
				<el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="adjustObjQuery.createTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:250px;"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="adjustObjQuery.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:250px;"
				></el-date-picker>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleAdjustObjDataSearch">搜索</el-button>
            </div>
			<el-table
                :data="adjustObjData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
				@row-dblclick = "rowSelect"
            >
				<el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="companyName" label="名称" width="200"></el-table-column>
				<el-table-column prop="amount" label="金额" width="100"></el-table-column>
				<el-table-column prop="tranTime" label="时间" width="160"></el-table-column>
            </el-table>
			<div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="adjustObjQuery.pageIndex"
                    :page-size="adjustObjQuery.pageSize"
                    :total="adjustObjPageTotal"
                    @current-change="handleAdjustObjPageChange"
                ></el-pagination>
            </div>
        </el-dialog>
		
		<el-dialog title="详情" :visible.sync="showVisible" width="40%">
			<el-form ref="show" :model="show" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" labelStyle="width:160px;" border>
					<el-descriptions-item>
						<template slot="label">
							调整对象类型
						</template>
						{{adjustObjTypeFormat(null, null, show.adjustObjType)}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.adjustObjType > 0">
						<template slot="label">
							关联内容
						</template>
						{{adjustObjTypeFormat(null, null, show.title)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							调整方式
						</template>
						{{adjustWayFormat(null, null, show.adjustWay)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							记账期号
						</template>
						{{show.period}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							会计类型
						</template>
						{{accountingTypeFormat(null, null, show.accountingType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							记账对象名称
						</template>
						{{show.companyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							金额
						</template>
						￥{{show.amount}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							摘要
						</template>
						￥{{show.purpose}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							调整备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
		</el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchAccountingAdjustData, saveAccountingAdjust, deleteAccountingAdjust, getAccountingAdjust, 
getAccountingAdjustObjectKv, getAccountingAdjustWayKv, getAccountingTypeKV, fetchAccountingAdjustObjData} from '../../../api/index';
export default {
    name: 'accounting-adjust',
    data() {
		let checkNum = (rule, value, callback) => {
			const mailReg = /^[0-9]*$/
			if (value) {
				if (mailReg.test(value)) {
					callback()
				} else {
					callback(new Error('编码为数值型'));
				}
			} else {
				callback(new Error('请输入编码'));
			}
		}
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			show: {},
			title:"",
			showVisible:false,
			rules: {
                adjustObjType: [{ required: true, message: '请选择调整对象类型', trigger: 'blur' }],
				adjustWay: [{ required: true, message: '请选择调整方式', trigger: 'blur' }],
				adjustKey: [{ required: true, message: '请选择关联内容', trigger: 'blur' }],				
				period: [{ required: true, message: '请选择记账期号', trigger: 'blur' }],
				accountingType: [{ required: true, message: '请选择财务类型', trigger: 'blur' }],
				companyName: [{ required: true, message: '请输入记账对象名称', trigger: 'blur' }],
				amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
				remark: [{ required: true, message: '请输入调整备注', trigger: 'blur' }],
            },
			controll:{},
			adjustObjectKv:[],
			adjustWayKv:[],
			accountingTypeKV:[],
			adjustObjData:[],
			adjustObjQuery:{
				pageNum: 1,
                pageSize: 10
			},
			adjustObjPageTotal:0,
			adjustDataTitle:"",
			adjustDataVisible:false
        };
    },
    created() {
		this.controll = getControll("accounting-adjust");
		this.getAdjustKv();
		this.getAccountingType();
        this.getData();
    },
    methods: {
        // 获取财务报表数据
        getData() {
            fetchAccountingAdjustData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
		//获取财务类型
		getAccountingType() {
			getAccountingTypeKV().then(res => { 
				if (res.code == 0 ) {
					this.accountingTypeKV = res.data;
				} else {
					this.$message.error(res.message);
				}
            });
		},
		//获取调整对象和方式
		getAdjustKv() {
			getAccountingAdjustObjectKv().then(res => {
				if (res.code == 0 ) {
					this.adjustObjectKv = res.data;
				} else {
					this.$message.error(res.message);
				}
			})
			getAccountingAdjustWayKv().then(res => {
				if (res.code == 0 ) {
					this.adjustWayKv = res.data;
				} else {
					this.$message.error(res.message);
				}
			})
		},
		adjustWayFormat(row, column, cellValue) {
			let index = this.adjustWayKv.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.adjustWayKv[index].value;
		},
		adjustObjTypeFormat(row, column, cellValue) {
			let index = this.adjustObjectKv.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.adjustObjectKv[index].value;
		},
		accountingTypeFormat(row, column, cellValue) {
			let index = this.accountingTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.accountingTypeKV[index].value;
		},
		adjustObjectFormat(row, column, cellValue) {
			let index = this.adjustObjectKv.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.adjustObjectKv[index].value;
		},
		adjustObjTypeChange(value) {
		    if (value == 0) {
				return;
			}
			this.adjustDataTitle = this.adjustObjectFormat(null, null, value);
			this.$set(this.adjustObjQuery, "adjustObjType", value);
			this.$set(this.adjustObjQuery, 'pageNum', 1);
			this.$set(this.adjustObjQuery, 'pageIndex', 1);
			this.getObjData(true);
		}, 
		//获取调整对象
		getObjData(openDialog) {
			//this.adjustObjData = [{"id":1, "title":"资金流水-货款","companyName":"深圳市泽立鑫自动化设备有限公司","amount":"5000.00","tranTime":"2024-11-22 14:35:55"}];
			//this.adjustObjPageTotal = 1;
			//if (openDialog) {
			//	this.adjustDataVisible = true;
			//}
			fetchAccountingAdjustObjData(this.adjustObjQuery).then(res => {
				if (res.code == 0 ) {
					this.adjustObjData = res.data.records;
					this.adjustObjPageTotal = res.data.total;
					if (openDialog) {
						this.adjustDataVisible = true;
					}
				} else {
					this.$message.error(res.message);
				}
			});
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccountingAdjust([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 显示详情操作
        handleShow(index, row) {
			getAccountingAdjust(row.id).then(res => {
				if (res.code == 0) {
					this.show = res.data;
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		// 编辑
		handleEdit(index, row) {
			this.title = "编辑";
			getAccountingAdjust(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据失败！` + res.message);
				}
			})
		},
		// 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveAccountingAdjust(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleAdjustObjDataSearch() {
            this.$set(this.adjustObjQuery, 'pageNum', 1);
			this.$set(this.adjustObjQuery, 'pageIndex', 1);
			this.$set(this.adjustObjQuery, 'adjustObjType', this.form.adjustObjType);
            this.getObjData(false);
        },
		//调整对象分页导航
		handleAdjustObjPageChange(val) {
            this.$set(this.adjustObjQuery, 'pageNum', val);
			this.$set(this.adjustObjQuery, 'pageIndex', val);
			this.$set(this.adjustObjQuery, 'adjustObjType', this.form.adjustObjType);
            this.getObjData(false);
        },
		rowSelect(row, colum) {
			this.$set(this.form, 'adjustKey', row.id);
			this.$set(this.form, 'title', row.title);
			this.$set(this.form, 'companyName', row.companyName);
			this.$set(this.form, 'amount', row.amount);
			this.adjustDataVisible = false;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

/deep/ .el-table .warning-row {
	background: #fafafa;
	font-size:14px;
}

</style>
